const venueActions = {
    GET_CANDIDATE_COUNT: 'GET_CANDIDATE_COUNT',
    SET_CANDIDATE_COUNT: 'SET_CANDIDATE_COUNT',
    GET_VENUE_DETAILS: 'GET_VENUE_DETAILS',
    SET_VENUE_DETAILS: 'SET_VENUE_DETAILS',
    GET_VENUE_DISTRICT_DETAILS:'GET_VENUE_DISTRICT_DETAILS',
    SET_VENUE_DISTRICT_DETAILS:'SET_VENUE_DISTRICT_DETAILS',
    SET_SEAT_ALLOCATION: 'SET_SEAT_ALLOCATION',
    GET_SEAT_ALLOCATION: 'GET_SEAT_ALLOCATION',
    GET_SEAT_ALLOCATION_DETAILS: 'GET_SEAT_ALLOCATION_DETAILS',
    SET_SEAT_ALLOCATION_DETAILS: 'SET_SEAT_ALLOCATION_DETAILS',
    GET_CANDIDATE_ALLOCATION_DEAILS: 'GET_CANDIDATE_ALLOCATION_DEAILS',
    SET_CANDIDATE_ALLOCATION_DEAILS: 'SET_CANDIDATE_ALLOCATION_DEAILS',
    GET_CATEGORIES_OF_COURSE: 'GET_CATEGORIES_OF_COURSE',
    SET_CATEGORIES_OF_COURSE: 'SET_CATEGORIES_OF_COURSE',

    UPLOAD_VENUE_DATA: 'UPLOAD_VENUE_DATA',
    IMPORT_VENUE_DATA_API: 'IMPORT_VENUE_DATA_API',
    RUN_SEAT_ALLOCATION: 'RUN_SEAT_ALLOCATION',
    RESET_SEAT_ALLOCATION: 'RESET_SEAT_ALLOCATION',
    STOP_SEAT_ALLOCATION: 'STOP_SEAT_ALLOCATION',


    UPLOAD_OTBS_VENUE:"UPLOAD_OTBS_VENUE",
    UPDATE_OTBS_VENUE:"UPDATE_OTBS_VENUE",
    OTBS_GET_VENUE:"OTBS_GET_VENUE",
    OTBS_SET_VENUE:"OTBS_SET_VENUE",
    GET_ALLOCATION_STATUS: "GET_ALLOCATION_STATUS",
    SET_ALLOCATION_STATUS: "SET_ALLOCATION_STATUS",

    // Duplicate candidates (placed together during seat allocation)
    GET_DUPLICATE_SUMMARY: "GET_DUPLICATE_SUMMARY",
    SET_DUPLICATE_SUMMARY: "SET_DUPLICATE_SUMMARY",
    REFRESH_DUPLICATES: "REFRESH_DUPLICATES",
    GET_DUPLICATE_GROUPS: "GET_DUPLICATE_GROUPS",
    SET_DUPLICATE_GROUPS: "SET_DUPLICATE_GROUPS",
    REVIEW_DUPLICATE_GROUP: "REVIEW_DUPLICATE_GROUP",
    GET_DUPLICATE_REPORT: "GET_DUPLICATE_REPORT",
    SET_DUPLICATE_REPORT: "SET_DUPLICATE_REPORT"

    
}

export default venueActions